
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoalibauginnovacrystacabservice() {



    const cardData =
    {
        keyword: 'Pune to Alibag Innova Crysta Cab Service',
        heading: 'Meghana Cab : Pune to Alibag Innova Crysta Cab Service',
        headingDescription: 'Meghana Cab offers premium Pune to Alibag Innova Crysta Cab Service, perfect for a relaxed and luxurious coastal getaway. Whether you are heading for a family vacation, a weekend escape, or a business trip, our Innova Crysta ensures maximum comfort with spacious seating, plush leather interiors, ample luggage room, and smooth air-conditioned rides. Enjoy the scenic drive from Pune to Alibag with our courteous, experienced chauffeurs offering door-to-door pick-up from Viman Nagar, Koregaon Park, Kalyani Nagar, or the airport area.',


        top: 'Top Places to Visit in Alibag with Meghana Cab',

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "description": "Located in the heart of Alibaug town, this black-sand beach offers panoramic views of the Arabian Sea and the historic Kolaba Fort. It's a popular spot for water sports like parasailing, jet skiing, and banana boat rides. The beach is also known for its picturesque sunrises and sunsets."
  },
  {
    "title": "Kolaba Fort",
    "description": "Built in the 17th century by Chhatrapati Shivaji Maharaj, Kolaba Fort is situated about 1–2 km from Alibaug Beach. Accessible during low tide by walking or by boat during high tide, the fort features ancient temples, bastions, and offers panoramic views of the Arabian Sea."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "An island fortress located about 55 km from Alibaug, Murud-Janjira Fort is renowned for its impressive architecture and historical significance. Accessible only by boat, the fort features 19 rounded bastions and a freshwater lake, making it a must-visit for history enthusiasts."
  },
  {
    "title": "Nagaon Beach",
    "description": "Approximately 7 km from Alibaug town, Nagaon Beach is known for its clean sands and clear waters. It's a popular destination for water sports like jet skiing, banana boat rides, and parasailing. The beach is also lined with coconut groves and shacks offering local delicacies."
  },
  {
    "title": "Kihim Beach",
    "description": "Situated about 12 km from Alibaug, Kihim Beach is a serene destination known for its clean sands and clear waters. The beach is lined with dense vegetation of coconut palms and pine trees, making it ideal for relaxation and nature walks."
  },
  {
    "title": "Akshi Beach",
    "description": "Located approximately 5 km from Alibaug town, Akshi Beach offers a peaceful retreat with its pristine white sand and calm waters. It's a great spot for swimming, sunbathing, and enjoying the natural beauty of the coastal area."
  },
  {
    "title": "Kanakeshwar Forest and Temple",
    "description": "Situated about 12 km from Alibaug, Kanakeshwar is a hilltop temple dedicated to Lord Shiva. The temple is reached by climbing 650 steps and offers panoramic views of the surrounding area. The forest surrounding the temple is rich in flora and fauna, making it a popular spot for nature lovers."
  },
  {
    "title": "Revdanda Fort",
    "description": "Located near the village of Revdanda, this fort offers a glimpse into the region's history. The fort's ruins are situated near the seashore, providing scenic views of the Arabian Sea. It's a peaceful spot for history buffs and nature enthusiasts alike."
  },
  {
    "title": "Mandwa Beach",
    "description": "Approximately 20 km from Alibaug, Mandwa Beach is known for its scenic beauty and water sports activities. It's a popular destination for those looking to enjoy jet skiing, kayaking, and stand-up paddleboarding. The beach is also accessible by ferry from Mumbai."
  },
  {
    "title": "Phansad Wildlife Sanctuary",
    "description": "Located about 140 km from Alibaug, Phansad Wildlife Sanctuary is a coastal woodland ecosystem of the Western Ghats. Established in 1986, the sanctuary is home to diverse flora and fauna, including several species of birds and animals. It's a haven for wildlife enthusiasts and nature photographers."
  }
],

  "services": [
    {
      "name": "Pune to Alibag Innova Crysta Cab Booking",
      "description": "Book your Innova Crysta cab for the Pune to Alibag route with Meghana Cab for seamless travel with professional drivers and comfortable rides."
    },
    {
      "name": "One Way Innova Crysta Pune Alibag",
      "description": "Opt for our one-way Innova Crysta cab service from Pune to Alibag for flexible and hassle-free travel."
    },
    {
      "name": "Round Trip Innova Crysta Pune Alibag",
      "description": "Book round-trip Innova Crysta services for your Pune-Alibag journey with reliable timing and comfortable return travel."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Alibag",
      "description": "Travel in comfort with our fully air-conditioned Innova Crysta taxis for the Pune to Alibag route, perfect for beating the heat."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Alibag",
      "description": "Enjoy professional chauffeur-driven Innova Crysta services ensuring safety and local route expertise between Pune and Alibag."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Alibag",
      "description": "Hire a private Innova Crysta taxi for exclusive and personalized travel from Pune to Alibag."
    },
    {
      "name": "Online Booking Innova Crysta Pune Alibag",
      "description": "Conveniently book your Pune to Alibag Innova Crysta cab online with instant confirmation and transparent pricing."
    },
    {
      "name": "Alibag Tour Innova Crysta",
      "description": "Explore Alibag’s beaches and attractions with our Innova Crysta cab service designed for sightseeing and tours."
    },
    {
      "name": "Beach Trip Innova Crysta Pune Alibag",
      "description": "Plan your beach getaway with comfortable Innova Crysta rides from Pune to Alibag, perfect for families and groups."
    },
    {
      "name": "Family Travel Innova Crysta Alibag",
      "description": "Spacious and safe Innova Crysta cabs ideal for family trips to and around Alibag."
    },
    {
      "name": "Comfortable Innova Crysta Taxi Pune Alibag",
      "description": "Experience smooth and comfortable travel with our Innova Crysta taxis on the Pune-Alibag route."
    },
    {
      "name": "Budget Innova Crysta Cab Pune Alibag",
      "description": "Affordable Innova Crysta cab rentals without compromising on comfort or service quality."
    },
    {
      "name": "Reliable Pune Alibag Innova Crysta",
      "description": "Count on Meghana Cab’s reliable Innova Crysta service for punctual and safe journeys between Pune and Alibag."
    },
    {
      "name": "Weekend Trip Innova Crysta Cab Alibag",
      "description": "Perfect Innova Crysta cab service for your weekend getaway plans from Pune to Alibag."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Expert long-distance Innova Crysta taxi services designed to provide comfort and safety on extended trips."
    }
  ],
  "tableData": [
    ["Pune to Alibag Innova Crysta Cab Booking", "One Way Innova Crysta Pune Alibag"],
    ["Round Trip Innova Crysta Pune Alibag", "AC Innova Crysta Taxi Pune Alibag"],
    ["Chauffeur Driven Innova Crysta Pune Alibag", "Private Innova Crysta Taxi Pune Alibag"],
    ["Online Booking Innova Crysta Pune Alibag", "Alibag Tour Innova Crysta"],
    ["Beach Trip Innova Crysta Pune Alibag", "Family Travel Innova Crysta Alibag"],
    ["Comfortable Innova Crysta Taxi Pune Alibag", "Budget Innova Crysta Cab Pune Alibag"],
    ["Reliable Pune Alibag Innova Crysta", "Weekend Trip Innova Crysta Cab Alibag"],
    ["Long Distance Innova Crysta Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Innova Crysta Car Rental in Viman Nagar",
    "WhyChoosedescription": "Rent our premium Innova Crysta in Viman Nagar for a comfortable and stylish ride. Whether you need a vehicle for airport transfers, local errands, or city tours, our car rental service offers unmatched convenience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Our Innova Crysta cabs provide ample seating for up to 7 passengers, with plush seats and sufficient luggage space—perfect for family outings or business travel within and around Viman Nagar."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure safe, timely, and courteous service. They are familiar with Viman Nagar and Pune city routes, providing smooth navigation and a hassle-free journey."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All our Innova Crysta cars undergo regular maintenance and thorough cleaning, maintaining high hygiene standards to ensure a safe and pleasant ride for you and your companions."
  },
  {
    "WhyChooseheading": "Flexible Rental Options to Suit Your Needs",
    "WhyChoosedescription": "Choose from hourly rentals, daily hires, or customized packages tailored to your schedule and travel requirements in Viman Nagar and beyond."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes fuel, driver allowance, taxes, and tolls, providing full transparency and excellent value for your Innova Crysta rental."
  },
  {
    "WhyChooseheading": "Ideal for Airport Transfers, Local Travel, and Business Trips",
    "WhyChoosedescription": "Whether you’re heading to Pune Airport, attending meetings, or exploring the city, our Innova Crysta rental service in Viman Nagar offers comfort and reliability."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Our customer service team is available around the clock to assist you with bookings, modifications, and any special requests, ensuring a smooth and convenient rental experience."
  }
]





















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Alibag?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or visit our website for a quick and convenient online booking."
    },
    {
        question: "What is the distance and travel time from Pune to Alibag?",
        answer: "The distance is around 140 km, and the travel time typically ranges between 3 to 4 hours depending on the route and traffic."
    },
    {
        question: "Is Innova Crysta a good option for the Pune to Alibag route?",
        answer: "Yes, Innova Crysta is ideal for comfortable and spacious travel on routes like Pune to Alibag."
    },
    {
        question: "Can I book a one-way or round trip to Alibag?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip options for Pune to Alibag travel."
    },
    {
        question: "What is included in the cab fare?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional charges may apply for waiting time or parking if required."
    },
    {
        question: "Is the Innova Crysta available for family or group travel to Alibag?",
        answer: "Absolutely. The Innova Crysta seats 6 to 7 passengers and is perfect for family or group outings."
    },
    {
        question: "Are the cabs sanitized before the trip?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before every journey to ensure your safety."
    },
    {
        question: "Do your drivers have experience with long-distance travel to Alibag?",
        answer: "Yes, our drivers are experienced and familiar with Pune–Alibag routes to ensure a safe and comfortable journey."
    },
    {
        question: "Is the Pune to Alibag cab service available 24/7?",
        answer: "Yes, we operate round-the-clock so you can schedule your journey at any time convenient to you."
    },
    {
        question: "What payment modes are accepted for the booking?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Swapnil Kamat',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Pune to Alibag. The car was clean, and the journey was smooth. The driver was very courteous and professional.”',
    },
    {
        name: 'Ms. Neha Sawant',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service! The Innova Crysta was spacious and comfortable, perfect for our trip to Alibag.”',
    },
];
































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneAlibagInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Alibag Innova Crysta Cab Service",
  "description": "Book chauffeur-driven Innova Crysta cabs from Pune to Alibag for beach trips, weekend getaways, and family tours. AC, comfortable, and budget-friendly one-way and round-trip Innova Crysta taxi services.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Cab Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Alibag"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-alibag-innova-crysta-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Alibag Innova Crysta Cab | Beach Trip Taxi Service</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs from Pune to Alibag for beach trips, weekend getaways, and family travel. Affordable and comfortable one-way and round-trip taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Alibag Innova Crysta Cab Booking, One Way Innova Crysta Pune Alibag, Round Trip Innova Crysta Pune Alibag, AC Innova Crysta Taxi Pune Alibag, Chauffeur Driven Innova Crysta Pune Alibag, Private Innova Crysta Taxi Pune Alibag, Online Booking Innova Crysta Pune Alibag, Alibag Tour Innova Crysta, Beach Trip Innova Crysta Pune Alibag, Family Travel Innova Crysta Alibag, Comfortable Innova Crysta Taxi Pune Alibag, Budget Innova Crysta Cab Pune Alibag, Reliable Pune Alibag Innova Crysta, Weekend Trip Innova Crysta Cab Alibag, Long Distance Innova Crysta Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneAlibagInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoalibauginnovacrystacabservice;